import React from 'react';
import Modal from 'react-modal';
import styles from './ElmerModalAlert.module.scss';

export type AlertButton = {
  label: string;
  onClick: () => void;
};

type Props = {
  alertTitle?: string;
  isModalOpen: boolean;
  alertText: string;
  alertButtons: Array<AlertButton>;
};

Modal.setAppElement('#root');

const ElmerModalAlert = React.memo<Props>(
  ({ alertTitle = '', isModalOpen = false, alertText, alertButtons }) => {
    // アラート文言(改行付き)
    const alertTextWithNewLine = alertText.split('\n').map((item) => (
      <>
        {item}
        <br />
      </>
    ));

    return (
      <>
        <Modal
          className={styles['elmer-alert-dialog']}
          overlayClassName={styles.overlay}
          isOpen={isModalOpen}
        >
          <div className={styles['elmer-alert-dialog-container']}>
            {alertTitle.length > 0 && (
              <div className={styles['elmer-alert-dialog-header']}>
                <div className={styles['elmer-alert-dialog-header-left']}>
                  <p>{alertTitle}</p>
                </div>
              </div>
            )}
            <div className={styles['elmer-alert-dialog-content']}>
              <div className={styles['content-primary']}>
                <p>{alertTextWithNewLine}</p>
              </div>
            </div>
            <div
              className={`${styles['elmer-alert-buttons']}  ${
                alertButtons.length === 1 ? styles['mod-right'] : ''
              }`}
            >
              {alertButtons.map((button: AlertButton, i) => (
                <button
                  type="button"
                  onClick={button.onClick}
                  className={`${styles['elmer-alert-dialog-button']} ${
                    styles['mod-horizontal']
                  } ${
                    i === 0 && alertButtons.length > 1
                      ? styles['mod-bordered']
                      : ''
                  } `}
                >
                  {button.label}
                </button>
              ))}
            </div>
          </div>
        </Modal>
      </>
    );
  },
);

export default ElmerModalAlert;
